import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  statusGlobal: "",
  province: [],
  district: [],
  subDistrict: [],
  statusInformation: null
}


const mutations = {
  toggleSidebarDesktop(state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile(state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  sidebarMinimize(state, value){
    state.sidebarMinimize = value
  },
  set(state, value) {
    state.statusGlobal = value
  },
  setArrayProvince(state, value) {
    state.province.push(value)
  },
  setArrayProvinceNull(state) {
    state.province = []
  },
  setArrayDistrict(state, value) {
    state.district.push(value)
  },
  setArrayDistrictNull(state) {
    state.district = []
  },
  setArraySubDistrict(state, value) {
    state.subDistrict.push(value)
  },
  setArraySubDistrictNull(state) {
    state.subDistrict = []
  },

  setStatusInformation(state, value) {
    state.statusInformation = value
  }
}

const getters = {
  getStatusGlobal: state => {
    return state.statusGlobal
  },
  getProvince: state => {
    return state.province
  },
  getDistrict: state => {
    return state.district
  },
  getSubDistrict: state => {
    return state.subDistrict
  },

  getStatusInformation: state => {
    return state.statusInformation
  },
}

export default new Vuex.Store({
  state,
  mutations,
  getters,
})
